import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowProjectsShowProjectVersionsShowIndexRoute extends BaseRoute {}
